import React from 'react';
import { Helmet } from 'react-helmet';
import './legal.css';

const Contact = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>Contact | dmyor</title>
        <link rel="canonical" href="https://www.dmyor.com/contact" />
        <meta name="description" content="Get in touch with the dmyor team for support, questions, or feedback about the platform." />
        <meta property="og:title" content="Contact | dmyor" />
        <meta property="og:description" content="Get in touch with the dmyor team for support, questions, or feedback about the platform." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dmyor.com/contact" />
        <meta property="og:image" content="https://dmyor.com/images/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact | dmyor" />
        <meta name="twitter:description" content="Get in touch with the dmyor team for support, questions, or feedback about the platform." />
        <meta name="twitter:image" content="https://dmyor.com/images/og-image.png" />
      </Helmet>

      <div className="legal-header">
        <div className="legal-eyebrow">dmyor</div>
        <h1>Contact</h1>
      </div>

      <div className="legal-body">
        <p>
          Whether you have a question, found something broken, want to share feedback,
          or just want to say something, we read everything that comes in.
        </p>
        <div className="legal-contact-card">
          <p>Reach us at</p>
          <a href="mailto:support@dmyor.com">support@dmyor.com</a>
          <p style={{ marginTop: '0.75rem' }}>We'll get back to you as soon as we can.</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
